var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tab-layout",
    {
      attrs: { buttons: _vm.buttons, permissions: _vm.permissionsToEdit },
      on: { edit: _vm.openEdit }
    },
    [
      _c("template", { slot: "title" }, [
        _vm._v("\n        " + _vm._s(_vm.$l10n.__("Préférences")) + "\n    ")
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "content" },
        [
          _vm.enableEdit && !_vm.metaLoading
            ? _c("EditPreferencesThird", {
                attrs: { metadata: _vm.metadata, preferences: _vm.preferences },
                on: {
                  close: function($event) {
                    _vm.enableEdit = false
                  },
                  saved: _vm.hasSaved
                }
              })
            : !_vm.loading
            ? _c("div", { staticClass: "well p-4 flex-level flex-top" }, [
                _c("div", { staticClass: "wp-5" }, [
                  _c("section", { staticClass: "mb-4" }, [
                    _c("h3", { staticClass: "mt-0 mb-2 lh-24 fs-4 bold" }, [
                      _vm._v(_vm._s(_vm.$l10n.__("Informations")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "article",
                      { staticClass: "mb-3" },
                      [
                        _c("p", { staticClass: "fs-3 lh-20 gray-60 m-0" }, [
                          _vm._v(_vm._s(_vm.$l10n.__("Devise")))
                        ]),
                        _vm._v(" "),
                        !_vm.preferences.currency.id
                          ? _c(
                              "p",
                              { staticClass: "fs-3 lh-20 semibold mt-1 mb-0" },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$l10n.__("Aucune devise spécifiée")
                                    ) +
                                    "\n                        "
                                )
                              ]
                            )
                          : [
                              _c(
                                "p",
                                {
                                  staticClass: "fs-3 lh-20 semibold mt-1 mb-0"
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.preferences.currency.symbol) +
                                      "\n                            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass: "fs-3 lh-20 semibold mt-1 mb-0"
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.preferences.currency.name) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ]
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "article",
                      { staticClass: "mb-3" },
                      [
                        _c("p", { staticClass: "fs-3 lh-20 gray-60 m-0" }, [
                          _vm._v(_vm._s(_vm.$l10n.__("Transporteur")))
                        ]),
                        _vm._v(" "),
                        !_vm.preferences.shipping.id
                          ? _c(
                              "p",
                              { staticClass: "fs-3 lh-20 semibold mt-1 mb-0" },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$l10n.__(
                                        "Aucun transporteur spécifié"
                                      )
                                    ) +
                                    "\n                        "
                                )
                              ]
                            )
                          : [
                              _c(
                                "p",
                                {
                                  staticClass: "fs-3 lh-20 semibold mt-1 mb-0"
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.preferences.shipping.name) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ]
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("article", { staticClass: "mb-3" }, [
                      _c("p", { staticClass: "fs-3 lh-20 gray-60 m-0" }, [
                        _vm._v(_vm._s(_vm.$l10n.__("TVA par défaut")))
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "fs-3 lh-20 semibold mt-1 mb-0" },
                        [
                          !!_vm.preferences.tax.label
                            ? _c("span", [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.preferences.tax.label) +
                                    " -\n                            "
                                )
                              ])
                            : _vm._e(),
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.preferences.tax.rate) +
                              "\n                        "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("article", { staticClass: "mb-3" }, [
                      _c("p", { staticClass: "fs-3 lh-20 gray-60 m-0" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$l10n.__("Délai de règlement")) +
                            "\n                        "
                        )
                      ]),
                      _vm._v(" "),
                      !_vm.metaLoading
                        ? _c(
                            "p",
                            { staticClass: "fs-3 lh-20 semibold mt-1 mb-0" },
                            [
                              _vm.currentPaymentTerm.code === "xdays"
                                ? _c("span", { staticClass: "ml-1" }, [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.preferences.paymentTerm.xDays
                                        ) +
                                        "\n                                " +
                                        _vm._s(
                                          _vm.$l10n.n__(
                                            "jour",
                                            "jours",
                                            _vm.preferences.paymentTerm.xDays
                                          )
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.preferences.paymentTerm.label
                                        ) +
                                        "\n                            "
                                    )
                                  ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.preferences.paymentTerm.endOfMonth
                        ? _c(
                            "p",
                            { staticClass: "fs-3 lh-20 semibold mt-3 mb-0" },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$l10n.__("En fin de mois")) +
                                  "\n                        "
                              )
                            ]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _c("article", { staticClass: "mb-3" }, [
                      _c("p", { staticClass: "fs-3 lh-20 gray-60 m-0" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(_vm.$l10n.__("Réduction globale")) +
                            "\n                        "
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "p",
                        { staticClass: "fs-3 lh-20 semibold mt-1 mb-0" },
                        [
                          _vm._v(
                            "\n                            " +
                              _vm._s(
                                _vm._f("numberformat")(
                                  _vm.preferences.discount.amount
                                )
                              ) +
                              "\n                            "
                          ),
                          _vm.preferences.discount.isAmountDiscount
                            ? _c("span", [_vm._v("€")])
                            : _vm.preferences.discount.isPercentDiscount
                            ? _c("span", [_vm._v("%")])
                            : _vm._e()
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "article",
                      [
                        _c("p", { staticClass: "fs-3 lh-20 gray-60 m-0" }, [
                          _vm._v(_vm._s(_vm.$l10n.__("Compte bancaire")))
                        ]),
                        _vm._v(" "),
                        !_vm.preferences.bankAccount.id
                          ? _c(
                              "p",
                              { staticClass: "fs-3 lh-20 semibold mt-1 mb-0" },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$l10n.__(
                                        "Aucun compte bancaire spécifié"
                                      )
                                    ) +
                                    "\n                        "
                                )
                              ]
                            )
                          : [
                              _c(
                                "p",
                                {
                                  staticClass: "fs-3 lh-20 semibold mt-1 mb-0"
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(
                                        _vm.preferences.bankAccount.label
                                      ) +
                                      "\n                            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass: "fs-3 lh-20 semibold mt-1 mb-0"
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(_vm.preferences.bankAccount.iban) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ],
                        _vm._v(" "),
                        _vm.preferences.discountByRow
                          ? _c(
                              "p",
                              { staticClass: "fs-3 lh-20 semibold mt-3 mb-0" },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$l10n.__(
                                        "Chaque ligne peut avoir sa remise spécifique"
                                      )
                                    ) +
                                    "\n                        "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.isSupplier && Object.keys(_vm.preferences.dunning).length
                    ? _c("section", [
                        _c("h3", { staticClass: "mt-0 mb-2 lh-24 fs-4 bold" }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$l10n.__("Plan de relance")) +
                              "\n                    "
                          )
                        ]),
                        _vm._v(" "),
                        _vm.preferences.dunning.estimate
                          ? _c("article", { staticClass: "pref-dunning" }, [
                              _c(
                                "p",
                                { staticClass: "fs-3 lh-20 gray-60 m-0" },
                                [_vm._v(_vm._s(_vm.$l10n.__("Plan des Devis")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass: "fs-3 lh-20 semibold mt-1 mb-0"
                                },
                                [
                                  _vm.preferences.dunning.estimate.value ===
                                  "main"
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$l10n.__(
                                                "Utiliser le plan par défaut"
                                              )
                                            ) +
                                            "\n                            "
                                        )
                                      ])
                                    : _vm.preferences.dunning.estimate.value ===
                                      "disabled"
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(_vm.$l10n.__("Désactiver")) +
                                            "\n                            "
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.preferences.dunning.estimate
                                              .label
                                          )
                                        )
                                      ])
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.preferences.dunning.invoice
                          ? _c("article", { staticClass: "pref-dunning" }, [
                              _c(
                                "p",
                                { staticClass: "fs-3 lh-20 gray-60 m-0" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$l10n.__("Plan des Factures")
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass: "fs-3 lh-20 semibold mt-1 mb-0"
                                },
                                [
                                  _vm.preferences.dunning.invoice.value ===
                                  "main"
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$l10n.__(
                                                "Utiliser le plan par défaut"
                                              )
                                            ) +
                                            "\n                            "
                                        )
                                      ])
                                    : _vm.preferences.dunning.invoice.value ===
                                      "disabled"
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(_vm.$l10n.__("Désactiver")) +
                                            "\n                            "
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.preferences.dunning.invoice
                                              .label
                                          )
                                        )
                                      ])
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.preferences.dunning.proforma
                          ? _c("article", { staticClass: "pref-dunning" }, [
                              _c(
                                "p",
                                { staticClass: "fs-3 lh-20 gray-60 m-0" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$l10n.__("Plan des Proforma")
                                      ) +
                                      "\n                        "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "p",
                                {
                                  staticClass: "fs-3 lh-20 semibold mt-1 mb-0"
                                },
                                [
                                  _vm.preferences.dunning.proforma.value ===
                                  "main"
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.$l10n.__(
                                                "Utiliser le plan par défaut"
                                              )
                                            ) +
                                            "\n                            "
                                        )
                                      ])
                                    : _vm.preferences.dunning.proforma.value ===
                                      "disabled"
                                    ? _c("span", [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(_vm.$l10n.__("Désactiver")) +
                                            "\n                            "
                                        )
                                      ])
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.preferences.dunning.proforma
                                              .label
                                          )
                                        )
                                      ])
                                ]
                              )
                            ])
                          : _vm._e()
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "wp-5" }, [
                  _c("section", [
                    !_vm.isSupplier
                      ? _c("article", { staticClass: "mb-3" }, [
                          _c("p", { staticClass: "fs-3 lh-20 gray-60 m-0" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$l10n.__("Catégorie tarifaire")) +
                                "\n                        "
                            )
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            { staticClass: "fs-3 lh-20 semibold mt-1 mb-0" },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.preferences.rateCategory.label) +
                                  "\n                        "
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "article",
                      [
                        _c("p", { staticClass: "fs-3 lh-20 gray-60 m-0" }, [
                          _vm._v(
                            "\n                            " +
                              _vm._s(_vm.$l10n.__("Moyen de règlement")) +
                              "\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.preferences.payMediums, function(medium) {
                          return _c(
                            "p",
                            {
                              key: medium.value,
                              staticClass: "fs-3 lh-20 semibold mt-1 mb-0"
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(medium.label) +
                                  "\n                        "
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        !_vm.preferences.payMediums.length
                          ? _c(
                              "p",
                              { staticClass: "fs-3 lh-20 semibold mt-1 mb-0" },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.$l10n.__(
                                        "Aucun moyen de règlement spécifié"
                                      )
                                    ) +
                                    "\n                        "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                ])
              ])
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }